import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { ConfigUpdateModel } from "../models/configUpdateModel";
import { MessageConfigModel } from "../models/messageConfigModel";
import { MessageTemplateModel } from "../models/messageTemplateModel";
import { TemplateUpdateModel } from "../models/templateUpdateModel";

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class TextConfigurationService {
  private baseUrl: string = '';
  private templateController: string = '';
  private configController: string = '';
  private appConfig!: AppConfigurations;

  constructor(private appInitService: AppInitService, private http: HttpClient) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }

  private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.baseUrl = this.appConfig.notificationApi.baseApiUrl;
    this.templateController = this.appConfig.notificationApi.templateController;
    this.configController = this.appConfig.notificationApi.configController;
  }

  /*
  * Get the appointment templates
  */
  public fetchTemplate(notifyEvent: string, via: string): Observable<MessageTemplateModel> {
    const url = `${this.baseUrl}${this.templateController}?notifyEvent=${notifyEvent}&via=${via}`;
    return this.http.get<MessageTemplateModel>(url);
  }

  public saveTemplate(templateId: number, data: TemplateUpdateModel): Observable<any> {
    const url = `${this.baseUrl}${this.templateController}${templateId}`;
    return this.http.patch<any>(url, data);
  }

  public fetchConfigurationPublic(messageType: string): Observable<MessageConfigModel> {
    const url = `${this.baseUrl}${this.configController}${messageType}/public`;
    return this.http.get<MessageConfigModel>(url);
  }

  public fetchConfiguration(messageType: string): Observable<MessageConfigModel> {
    const url = `${this.baseUrl}${this.configController}${messageType}`;
    return this.http.get<MessageConfigModel>(url);
  }

  public saveConfiguration(messageType: string, data: ConfigUpdateModel): Observable<any> {
    const url = `${this.baseUrl}${this.configController}${messageType}`;
    return this.http.patch<any>(url, data);
  }
}
